module.exports = __webpack_public_path__ + "img/project-02-03.f668b351.png";